import { Injectable } from '@angular/core';

import { joinClub } from './callables';

/**
 * The joinClub Callable behind an injectable seam.
 *
 * Exists for exactly one reason: the auto-join guard needs a mockable
 * dependency (Angular's vitest harness forbids vi.mock on relative
 * imports), and TestBed-provided stubs are the house pattern anyway.
 */
@Injectable({ providedIn: 'root' })
export class ClubJoin {
  /** Idempotent - see the Callable's contract in data/callables. */
  async join(clubId: string): Promise<void> {
    await joinClub({ clubId });
  }
}
